module.exports = window && window.$ ? $ : {};
